module.exports = __webpack_public_path__ + "img/empty.893a934c.png";